import { Tooltip } from "antd";
import React from "react";
import moment from 'moment';
import { currentUser, userCanEdit } from "modules/utilities/utility";
const CLICK_POST_URL = 'https://form.traya.health/returns';

function ReturnOrderButton({ order, buttonText, customer }) {
  
  const validDate = userCanEdit.includes(currentUser)?400:7;

  return (
    <div>
      <Tooltip title="Return order request">
        {(order.sub_status === "delivered"|| order.status === 'delivered') && moment().diff(moment(order.delivery_date),'days') <= validDate? (
            <span
            onClick={()=>{
              const userPhoneNo = customer.user.phone_number;
              const orderDisplayId = order.order_display_id.replace('#', '');
              const url = `${CLICK_POST_URL}?order_id=${orderDisplayId}&mobile=${userPhoneNo.replace("+91", "")}&token=${order.clickpost_security_key}`;
              window.open(url)
            }}
              className={`mt-n1 bg-primary text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow`}
            >
              {buttonText}
            </span>
        ) : (
          <span
            className={`mt-n1 bg-primary disabled-action text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow`}
          >
            {buttonText}
          </span>
        )}
      </Tooltip>
    </div>
  );
}

export default ReturnOrderButton;
